import React, { Component } from 'react';

import classNames from 'classnames';
import { Loading } from 'components/cosmos';
import Settings from 'configs/Settings';
import { observer } from 'mobx-react';
import PlayerMessageDispatcher from 'modules/player/components/PlayerMessageDispatcher';
import PlayerService from 'modules/player/PlayerService';
import PropTypes from 'prop-types';

import './Player.scss';

const DEFAULT_PLAYER_HEIGHT = 560;
const DEFAULT_PLAYER_WIDTH = 315;

@observer
class Player extends Component {
  iframeRef = React.createRef();

  state = {
    signature: null,
    token: null,
    mediaUrl: null
  };

  static propTypes = {
    mediaId: PropTypes.string,
    className: PropTypes.string,
    height: PropTypes.number,
    width: PropTypes.number,
    hideControls: PropTypes.bool,
    isPublic: PropTypes.bool,
    onLoad: PropTypes.func,
    loading: PropTypes.bool,
    playerMessageDispatcher: PropTypes.instanceOf(PlayerMessageDispatcher)
  };

  static defaultProps = {
    height: DEFAULT_PLAYER_HEIGHT,
    width: DEFAULT_PLAYER_WIDTH,
    playerMessageDispatcher: new PlayerMessageDispatcher()
  };

  componentDidMount() {
    const { isPublic } = this.props;

    if (!isPublic) {
      try {
        this.setMediaUrl();
      } catch {
        try {
          this.setFallbackMediaUrl();
          // eslint-disable-next-line no-empty
        } catch {}
      }
    }
  }

  componentWillUnmount() {
    this.iframeRef?.current?.removeEventListener('load', this.onLoad);
  }

  onLoad = (event) => {
    const { onLoad } = this.props;

    onLoad?.(event);
  };

  setIframeRef = (node) => {
    this.iframeRef = node;
    this.props.playerMessageDispatcher.iframe = node;
    this.iframeRef?.current?.addEventListener('load', this.onLoad);
  };

  setMediaUrl = async () => {
    const { mediaId } = this.props;

    if (mediaId) {
      this.setState({ mediaUrl: await PlayerService.fetchMediaUrl(mediaId) });
    }
  };

  setFallbackMediaUrl = async () => {
    const { mediaId } = this.props;
    const { urlEncodedSignature, applicationKey } =
      await PlayerService.generateSignature(mediaId);

    this.setState({
      signature: urlEncodedSignature,
      token: applicationKey,
      mediaUrl: `${Settings.url.playerEmbed}/${mediaId}`
    });
  };

  getMediaUrlParams = () => {
    const { signature, token } = this.state;
    const params = new URLSearchParams();

    token && params.append('token', token);
    signature && params.append('signature', signature);

    return params.toString();
  };

  get src() {
    const { mediaUrl } = this.state;

    if (mediaUrl) {
      const separator = mediaUrl.includes('?') ? '&' : '?';

      return `${mediaUrl}${separator}${this.getMediaUrlParams()}`;
    }

    return null;
  }

  get renderIframe() {
    const { height, width } = this.props;

    if (this.src) {
      return (
        <iframe
          ref={this.setIframeRef}
          width={height}
          height={width}
          src={this.src}
          className="player__iframe"
          allow="autoplay; encrypted-media;"
          allowFullScreen
        />
      );
    }
  }
  render() {
    const { className = '', loading } = this.props;

    return (
      <div
        className={classNames('player', className, {
          'player--loading': loading
        })}
      >
        {loading ? <Loading center className="_h-full" /> : this.renderIframe}
      </div>
    );
  }
}

export default Player;
